import { z } from 'zod';

export type AddAccountResponse = {
	id: number;
	parents: string;
	name: string;
	note?: string;
	isLocked: boolean;
	createdAt: string;
	updatedAt: string;
	wallets: {
		balance: number;
		currency: string;
		id: number;
	}[];
};

export const addAccountResponseSchema = z.object({
	id: z.number(),
	parents: z.string(),
	name: z.string().min(1),
	note: z.string().optional(),
	isLocked: z.boolean(),
	createdAt: z.string(),
	updatedAt: z.string(),
	wallets: z
		.object({
			balance: z.number(),
			currency: z.string(),
			id: z.number(),
		})
		.array(),
});
